import { configureStore } from "@reduxjs/toolkit";

import loginReducer from "./loginSlice";
import permissionDataReducer from "./userSlice";
import cmdDataReducer from "./cmsSlice";
import screenSizeReducer from "./screenSize";
import navbarReducer from "./navbarSlice";

// Central Redux store that wires together auth, permissions, CMS, responsive layout,
// and navbar state for the app.
const store = configureStore({
  reducer: {
    login: loginReducer,
    userPermission: permissionDataReducer,
    cmsData: cmdDataReducer,
    screenSize: screenSizeReducer,
    navbar: navbarReducer,
  },
});

export default store;
